module.exports = __webpack_public_path__ + "img/q2-4-active.150066ac.png";